type TDiffPart = { text: string; type: "equal" | "added" | "removed" }

/**
 * Word-level diff using LCS (Longest Common Subsequence).
 * Works well for short-to-medium texts like meeting analysis fields.
 */
export function computeWordDiff(oldText: string, newText: string): TDiffPart[] {
  const oldWords = oldText.split(/(\s+)/)
  const newWords = newText.split(/(\s+)/)
  const n = oldWords.length
  const m = newWords.length

  // Build LCS table
  const dp: number[][] = Array.from({ length: n + 1 }, () => new Array(m + 1).fill(0))
  for (let i = 1; i <= n; i++) {
    for (let j = 1; j <= m; j++) {
      if (oldWords[i - 1] === newWords[j - 1]) {
        dp[i][j] = dp[i - 1][j - 1] + 1
      } else {
        dp[i][j] = Math.max(dp[i - 1][j], dp[i][j - 1])
      }
    }
  }

  // Backtrack to produce diff
  const result: TDiffPart[] = []
  let i = n
  let j = m
  while (i > 0 || j > 0) {
    if (i > 0 && j > 0 && oldWords[i - 1] === newWords[j - 1]) {
      result.unshift({ text: oldWords[i - 1], type: "equal" })
      i--
      j--
    } else if (j > 0 && (i === 0 || dp[i][j - 1] >= dp[i - 1][j])) {
      result.unshift({ text: newWords[j - 1], type: "added" })
      j--
    } else {
      result.unshift({ text: oldWords[i - 1], type: "removed" })
      i--
    }
  }

  return result
}
